export const soilTypeData = [
  {
    id: 1,
    name: '岩屑土',
  },
  {
    id: 2,
    name: '砂丘未熟土',
  },
  {
    id: 3,
    name: '黒ボク土',
  },
  {
    id: 4,
    name: '多湿黒ボク土',
  },
  {
    id: 5,
    name: '黒ボクグライ土',
  },
  {
    id: 6,
    name: '褐色森林土',
  },
  {
    id: 7,
    name: '灰色台地土',
  },
  {
    id: 8,
    name: 'グライ台地土',
  },
  {
    id: 9,
    name: '赤色土',
  },
  {
    id: 10,
    name: '黄色土',
  },
  {
    id: 11,
    name: '暗赤色土',
  },
  {
    id: 12,
    name: '褐色低地土',
  },
  {
    id: 13,
    name: '灰色低地土',
  },
  {
    id: 14,
    name: 'グライ土',
  },
  {
    id: 15,
    name: '黒泥土',
  },
  {
    id: 16,
    name: '泥炭土',
  },
];
